import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
    FETCH_FLOOR_PLANS_CONTENT,
    FETCH_FLOOR_PLANS_CONTENT_SUCCESS,
    FETCH_FLOOR_PLANS_CONTENT_FAILED,
    FLOOR_PLANS_DELETE__MESSAGE,
    FLOOR_PLANS_DELETE_MESSAGE_SUCCESS,
    FLOOR_PLANS_DELETE__MESSAGE_FAILED
} from "./actionTypes";

export const fetchFloorPlans = () => (dispatch) => {
    dispatch({
        type: FETCH_FLOOR_PLANS_CONTENT,
        payload: null
    });
    http
        .get("floor-plans")
        .then(({ data }) => {
            dispatch({
                type: FETCH_FLOOR_PLANS_CONTENT_SUCCESS,
                payload: data
            });
        })
        .catch((error) => {
            dispatch({
                type: FETCH_FLOOR_PLANS_CONTENT_FAILED,
                payload: error
            });
        });
};


export const deleteFloorPlan = (formData) => (dispatch) => {
    dispatch({
        type: FLOOR_PLANS_DELETE__MESSAGE,
        payload: null
    });
    http
        .post('delete-floor-plan/' + formData, helpers.doObjToFormData(formData))
        .then(({ data }) => {
            if (data.status) {
                toast.success(
                    `${data.msg}`,
                    TOAST_SETTINGS
                );
                setTimeout(() => {
                    window.location.replace("/floor-plans");
                }, 2000);
                dispatch({
                    type: FLOOR_PLANS_DELETE_MESSAGE_SUCCESS,
                    payload: data
                });
            } else {
                toast.error(
                    <Text string={data.msg} parse={true} />,
                    TOAST_SETTINGS
                );
                dispatch({
                    type: FLOOR_PLANS_DELETE__MESSAGE_FAILED,
                    payload: null
                });
            }
        })
        .catch((error) => {
            dispatch({
                type: FLOOR_PLANS_DELETE__MESSAGE_FAILED,
                payload: error
            });
        });
};